import { render, staticRenderFns } from "./canalesVenta.vue?vue&type=template&id=b0c39636"
import script from "./canalesVenta.vue?vue&type=script&lang=js"
export * from "./canalesVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports